import { AsistenteEnLineaUtils } from "./../../utils/asistente-en-linea.utils";
import { HandlerType } from "./../../models/HandlerType";
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostListener, AfterContentInit } from "@angular/core";
import { Contexto } from "../../models/contexto";
import { LocalStorageService } from "../../services/local-storage.service";

@Component({
  selector: "app-asistencia-menu-arbol",
  templateUrl: "./asistencia-menu-arbol.component.html",
  styleUrls: ["./asistencia-menu-arbol.component.scss"],
})
export class AsistenciaMenuArbolComponent implements OnInit, AfterContentInit, OnDestroy {
  @Input() public ctx: Contexto;
  @Output() renderMenuArbolEmitter = new EventEmitter<Object>();

  constructor(private localstorage: LocalStorageService,
    private util: AsistenteEnLineaUtils) {

  }
  u
  ngOnInit() {
    this.localstorage.setWindowStatus('max');
    this.localstorage.setHandlerType('menuArbol');
  }

  ngOnDestroy(): void {
  }

  ngAfterContentInit() {
    console.log("===Inicializado===");
  }
  emitRenderMenuArbol(event) {
    this.renderMenuArbolEmitter.emit(event);
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event: Event) {
  }
}
